// Modules
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';

// Types
import type { MouseEventHandler } from 'react';
import type { TModalProps } from './Modal.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { MODAL_DEFAULT_PROPS } from './Modal.constant';

const Modal = (props: TModalProps) => {
	const {
		children,
		className,
		isOpen = MODAL_DEFAULT_PROPS.isOpen,
		onClose,
		overlayClassName,
		...restProps
	} = props

	const modalOverlayCN = cn(styles.legion_modal_overlay, overlayClassName)
	const modalCN = cn(styles.legion_modal, className)

	useEffect(() => {
		// Makes the body unscrollable when the Modal is open
		if (isOpen) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = 'auto'
		}
	}, [isOpen])

	const handleClose: MouseEventHandler<HTMLDivElement> = (e) => {
		e.stopPropagation()
		onClose?.()
	}

	return isOpen && createPortal((
			<div className={styles.legion_modal_wrapper}>
				<div className={modalOverlayCN} onClick={handleClose}/>
				<div className={modalCN} {...restProps}>
					{children}
				</div>
			</div>
		),
		document.body
	)
}

export default Modal;
